// extracted by mini-css-extract-plugin
export default {"tabs-container":"Tabs_tabs-container__QvNuO"};